import { useMemo } from 'react';

import { SideNavProps, useCurrentCompanyId, useCurrentUserScopeForCurrentCompany } from '@neo.tax/shared';
import { useSredContext } from '@neo.tax/sred/context';
import { getSredNavSection } from '@neo.tax/sred/utils';

export const useSredNavSections = (): SideNavProps['sections'] => {
  const companyId = useCurrentCompanyId();
  const { fiscalYearId } = useSredContext();
  const { limitAccessToFinancialData } = useCurrentUserScopeForCurrentCompany();

  return useMemo(
    () =>
      getSredNavSection({
        companyId,
        fiscalYearId,
        isNonFinancialUser: limitAccessToFinancialData,
      }),
    [companyId, fiscalYearId, limitAccessToFinancialData],
  );
};
